import { useRef } from "react";

import { useTranslations } from "next-intl";

import { Icon } from "@/components/icons/Icon";
import { Sidebar } from "@/components/sidebar";
import { twMerge } from "@/utils/twMerge";

import type { ChatModel } from "@/models/chat/ChatModel";

export function ChatUploadButton({ chat }: { chat: ChatModel }) {
  const t = useTranslations();
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFilesSelected = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { files } = event.target;
    if (files?.length) {
      chat.uploadFiles(files).catch((err) => {
        console.error("Failed to upload chat files:", err);
      });
    }
    event.target.value = "";
  };

  return (
    <>
      <Sidebar.Button
        className={twMerge(
          "w-8 h-8 min-w-8 min-h-8 sm:w-8 sm:h-8 sm:min-w-8 sm:min-h-8",
          "active:bg-sidebar-button-active-bg active:[--color-icon-main:var(--color-icon-active)]",
        )}
        title={t("chat.uploadFile")}
        wrapperClassName="p-0"
        type="button"
        onClick={() => inputRef.current?.click()}
      >
        <Icon name="PlusLarge" />
      </Sidebar.Button>
      <input
        ref={inputRef}
        className="hidden"
        tabIndex={-1}
        type="file"
        multiple
        onChange={handleFilesSelected}
      />
    </>
  );
}
